module.exports = __webpack_public_path__ + "media/img/pages/companies/yuh-a0af7627dfc98001e5c93b0fde9a4415.png";